function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26.197 38.488H10.028c-1.927 0-3.489-1.706-3.489-3.81v-22.51c0-2.104 1.562-3.81 3.49-3.81h27.916c1.928 0 3.49 1.706 3.49 3.81v13.408M6.54 16.156h34.892m-8.246-9.43v5.172M15.336 6.5v5.17",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.107 42.384c5.493 0 9.946-4.453 9.946-9.945 0-5.493-4.453-9.945-9.946-9.945-5.492 0-9.945 4.452-9.945 9.945 0 5.492 4.453 9.945 9.945 9.945z",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.107 26.681v6.805l3.403 3.402",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjE5NjkgMzguNDg3OEMxOS44MzczIDM4LjQ4NzggMTAuMDI4NCAzOC40ODc4IDEwLjAyODQgMzguNDg3OEM4LjEwMTI3IDM4LjQ4NzggNi41MzkwNiAzNi43ODIgNi41MzkwNiAzNC42Nzc5VjEyLjE2NzhDNi41MzkwNiAxMC4wNjM3IDguMTAxMjcgOC4zNTc5MSAxMC4wMjg0IDguMzU3OTFIMzcuOTQ1NEMzOS44NzI1IDguMzU3OTEgNDEuNDM0NyAxMC4wNjM3IDQxLjQzNDcgMTIuMTY3OFYyNS41NzY0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuNTM5MDYgMTYuMTU2M0MyMC4xNjU2IDE2LjE1NjMgNDEuNDMyIDE2LjE1NjMgNDEuNDMyIDE2LjE1NjNNMzMuMTg2MyA2LjcyNTU5VjExLjg5ODJNMTUuMzM2MyA2LjVWMTEuNjciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuMTA3NCA0Mi4zODQyQzM5LjYgNDIuMzg0MiA0NC4wNTI2IDM3LjkzMTUgNDQuMDUyNiAzMi40Mzg5QzQ0LjA1MjYgMjYuOTQ2MyAzOS42IDIyLjQ5MzcgMzQuMTA3NCAyMi40OTM3QzI4LjYxNDggMjIuNDkzNyAyNC4xNjIxIDI2Ljk0NjMgMjQuMTYyMSAzMi40Mzg5QzI0LjE2MjEgMzcuOTMxNSAyOC42MTQ4IDQyLjM4NDIgMzQuMTA3NCA0Mi4zODQyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0zNC4xMDc0IDI2LjY4MTJWMzMuNDg1OEwzNy41MDk3IDM2Ljg4ODEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgSchedule as ReactComponent };